import { RootState } from "../../index";
// get All Subscription Plan
export const getAPIKey = (state: RootState) => state.apikey.apiKey;
